import { GBlockStack, GObserver } from '~/presentation/ui';
import { Box, Scrollable } from '@shopify/polaris';
import { ScrollRank } from './ScrollRank';
import { useState } from 'react';

export const SidebarScrollMode: React.FC = () => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  return (
    <>
      <div className="gx-hm-divider" />
      <Box overflowY="hidden">
        <GBlockStack height="100%">
          <div
            style={{
              position: 'relative',
              height: '100%',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Scrollable
              scrollbarGutter="stable"
              scrollbarWidth="thin"
              vertical
              className="max-h-full"
            >
              <GObserver setIsIntersecting={setIsIntersecting}></GObserver>
              <ScrollRank isScrolled={!isIntersecting} />
            </Scrollable>
          </div>
        </GBlockStack>
      </Box>
    </>
  );
};
